// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Success_successStories__LzeRh {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: 90px;
    margin-bottom: 3rem;
}
.Success_successStories__LzeRh h1 {
    font-family: 'Cocon Bold';
    font-size: 3em;
}
.Success_successStories__LzeRh h2 {
    font-size: 2.5rem;
    font-weight: 700;
}
.Success_borderline__TmLgs {
    width: 90%;
    margin: 0 5%;
    margin-bottom: 2rem;
}

.Success_successStory__wlioK {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: left;
    margin-bottom: 0.5rem;
    width: 90%;
    border: 1px solid lightgray;
    box-shadow: 0px 0px 30px 15px #0000002b;
    border-radius: 0.5rem;
    background-color: transparent;
    font-size: 0.8rem;
}
.Success_successStory__wlioK h3 {
    font-weight: 700;
    font-size: 24px;
}
.Success_successStory__wlioK p {
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
}
.Success_storyContainer__weZPu {
    text-align: left;
    padding: 1.8rem;
    width: 100%;
}
.Success_storyContainer__weZPu p {
    padding-right: 1rem;
    font-family: 'Aktiv Grotesk', sans-serif;
}
.Success_beforeAfter__sn-\\+0 {
    height: 350px;
    float: right;
    margin-left: 0.5rem;
}
.Success_beforeAfterImg__-tXWw {
    width: auto;
    height: 350px;
}

@media screen and (max-width: 1150px) {
    .Success_beforeAfter__sn-\\+0 {
        height: 300px;
    }
    .Success_beforeAfterImg__-tXWw {
        width: auto;
        height: 300px;
    }
    .Success_successStories__LzeRh {
        width: 90%;
    }
}
@media screen and (max-width: 768px) {
    .Success_storyContainer__weZPu {
        margin: 0em 1em;
    }
    .Success_successStories__LzeRh {
        width: 98%;
    }
    .Success_successStories__LzeRh h2 {
        font-size: 1.75rem;
    }
    .Success_successStories__LzeRh h3 {
        font-size: 1.25rem;
    }
    .Success_successStories__LzeRh p {
        font-size: 14px;
    }    
    .Success_beforeAfter__sn-\\+0 {
        height: 250px;
    }
    .Success_beforeAfterImg__-tXWw {
        height: 250px;
    }
}
@media screen and (max-width: 586px) {
    .Success_storyContainer__weZPu {
        padding: 0.25rem;
        margin: 0;
    }
    .Success_successStories__LzeRh h1 {
        font-size: 2em;
    }
    .Success_beforeAfter__sn-\\+0 {
        height: 200px;
    }
    .Success_beforeAfterImg__-tXWw {
        height: 200px;
    }
}
@media screen and (max-width: 400px) {

    .Success_successStories__LzeRh {
        width: 100%;
    }
    .Success_successStories__LzeRh h1 {
        font-size: 1.5em;
        text-align: center;
    }
    .Success_successStory__wlioK {
        width: 98%;
    }
    .Success_beforeAfter__sn-\\+0 {
        height: 160px;
    }
    .Success_beforeAfterImg__-tXWw {
        height: 160px;
    }
}
@media screen and (max-width: 320px){
    .Success_beforeAfter__sn-\\+0 {
        float: none;
        text-align: center;
        margin-left: 0;        
    }
    .Success_successStory__wlioK h3 {
        text-align: center;
        margin: 0;
    }
    .Success_successStory__wlioK p {
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/SuccessStories/Success.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,UAAU;IACV,2BAA2B;IAC3B,uCAAuC;IACvC,qBAAqB;IACrB,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,wCAAwC;AAC5C;AACA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,SAAS;IACb;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ;AACA;;IAEI;QACI,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,WAAW;QACX,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,SAAS;IACb;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".successStories {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    margin-top: 90px;\n    margin-bottom: 3rem;\n}\n.successStories h1 {\n    font-family: 'Cocon Bold';\n    font-size: 3em;\n}\n.successStories h2 {\n    font-size: 2.5rem;\n    font-weight: 700;\n}\n.borderline {\n    width: 90%;\n    margin: 0 5%;\n    margin-bottom: 2rem;\n}\n\n.successStory {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: left;\n    margin-bottom: 0.5rem;\n    width: 90%;\n    border: 1px solid lightgray;\n    box-shadow: 0px 0px 30px 15px #0000002b;\n    border-radius: 0.5rem;\n    background-color: transparent;\n    font-size: 0.8rem;\n}\n.successStory h3 {\n    font-weight: 700;\n    font-size: 24px;\n}\n.successStory p {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 1.5;\n}\n.storyContainer {\n    text-align: left;\n    padding: 1.8rem;\n    width: 100%;\n}\n.storyContainer p {\n    padding-right: 1rem;\n    font-family: 'Aktiv Grotesk', sans-serif;\n}\n.beforeAfter {\n    height: 350px;\n    float: right;\n    margin-left: 0.5rem;\n}\n.beforeAfterImg {\n    width: auto;\n    height: 350px;\n}\n\n@media screen and (max-width: 1150px) {\n    .beforeAfter {\n        height: 300px;\n    }\n    .beforeAfterImg {\n        width: auto;\n        height: 300px;\n    }\n    .successStories {\n        width: 90%;\n    }\n}\n@media screen and (max-width: 768px) {\n    .storyContainer {\n        margin: 0em 1em;\n    }\n    .successStories {\n        width: 98%;\n    }\n    .successStories h2 {\n        font-size: 1.75rem;\n    }\n    .successStories h3 {\n        font-size: 1.25rem;\n    }\n    .successStories p {\n        font-size: 14px;\n    }    \n    .beforeAfter {\n        height: 250px;\n    }\n    .beforeAfterImg {\n        height: 250px;\n    }\n}\n@media screen and (max-width: 586px) {\n    .storyContainer {\n        padding: 0.25rem;\n        margin: 0;\n    }\n    .successStories h1 {\n        font-size: 2em;\n    }\n    .beforeAfter {\n        height: 200px;\n    }\n    .beforeAfterImg {\n        height: 200px;\n    }\n}\n@media screen and (max-width: 400px) {\n\n    .successStories {\n        width: 100%;\n    }\n    .successStories h1 {\n        font-size: 1.5em;\n        text-align: center;\n    }\n    .successStory {\n        width: 98%;\n    }\n    .beforeAfter {\n        height: 160px;\n    }\n    .beforeAfterImg {\n        height: 160px;\n    }\n}\n@media screen and (max-width: 320px){\n    .beforeAfter {\n        float: none;\n        text-align: center;\n        margin-left: 0;        \n    }\n    .successStory h3 {\n        text-align: center;\n        margin: 0;\n    }\n    .successStory p {\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"successStories": `Success_successStories__LzeRh`,
	"borderline": `Success_borderline__TmLgs`,
	"successStory": `Success_successStory__wlioK`,
	"storyContainer": `Success_storyContainer__weZPu`,
	"beforeAfter": `Success_beforeAfter__sn-+0`,
	"beforeAfterImg": `Success_beforeAfterImg__-tXWw`
};
export default ___CSS_LOADER_EXPORT___;
